import React from 'react'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { BodyInterface } from 'common/types/entities/body-interface'
import { usePage } from 'client/store'
import { getFirstEntityByType } from 'client/store/page/pageSelectors'
import { LanguageSelector } from '../options'
import CommonWithoutSeoSettingsOld from './CommonWithoutSeoSettings'
import Title from './components/Title'
import Tracking from './components/Tracking'
import { Typography } from './components/typography-new'
import { Affiliate } from './components/affiliate'
import { Background } from './components/background'

interface CommonWithoutSeoSettingsProps {
  isSkipFont?: boolean
}

export const CommonWithoutSeoSettingsResolver = ({
  isSkipFont = false,
}: CommonWithoutSeoSettingsProps) => {
  const isMigratedBodyEntity = usePage(page =>
    getFirstEntityByType(page, EntityTypeEnum.Body),
  )

  if (isMigratedBodyEntity) {
    return <CommonWithoutSeoSettings isSkipFont={isSkipFont} />
  }
  return <CommonWithoutSeoSettingsOld isSkipFont={isSkipFont} />
}

export const CommonWithoutSeoSettings = ({
  isSkipFont,
}: CommonWithoutSeoSettingsProps) => {
  // @description: for Body
  return (
    <>
      <Title />
      <Typography skipFont={isSkipFont} />
      <LanguageSelector />
      <Background<BodyInterface> />
      <Tracking />
      <Affiliate<BodyInterface> />
    </>
  )
}
